import { Box, styled, Typography, useTheme } from '@mui/material';
import React from 'react';
import { CustomChip } from '../CustomChip';
import { useLocation, useNavigate } from 'react-router-dom';

const AddedStatusInfoBox = styled(Box)(({ theme }) => ({
    borderRadius: `${theme.typography.borderRadius.xxSmall}`,
    background: theme.palette.brandPrimary[50],
    padding: `${theme.typography.generic.xxSmall} ${theme.typography.generic.medium}`,
    margin: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.none}`,

    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',

    width: 'fit-content',
}));

/**
 * ShowAddedTaskStatusBox - Component shows selectedStatusList of status name by which filter done
 * @param {*} param0
 * @returns
 */
function ShowAddedTaskStatusBox({ selectedStatusList = [], onRemoveTaskStatus = (e1, e2) => {}, sx = {}, ...props }) {
    const theme = useTheme();

    const navigate = useNavigate();
    const location = useLocation();

    const statusRemoveHandler = (currentStatus) => {
        const remainingList = selectedStatusList.filter((cItem) => {
            return cItem.id !== currentStatus.id;
        });

        // Create URLSearchParams
        const searchParams = new URLSearchParams(location.search);
        const filters = searchParams.getAll('status'); // Returns an array

        if (filters.find((cStatusId) => cStatusId === currentStatus.id)) {
            searchParams.delete('status', currentStatus.id || '');
            navigate(`${location.pathname}?${searchParams.toString()}`);
        }

        onRemoveTaskStatus && onRemoveTaskStatus(currentStatus, remainingList);
    };

    if (!selectedStatusList?.length) {
        return null;
    }

    return (
        <AddedStatusInfoBox sx={{ ...sx }} {...props}>
            <Typography component={'span'} color={'text.secondary'} fontSize={'customFontSize.small'} fontWeight={'fontWeightRegular'} marginRight={theme.typography.generic.xxSmall}>
                Task Status:
            </Typography>

            <Typography component={'p'} color={'text.secondary'} fontSize={'customFontSize.small'} fontWeight={'fontWeightMedium'}>
                {selectedStatusList.map((cItem, index) => (
                    <CustomChip
                        key={index}
                        label={cItem.status}
                        onDelete={() => statusRemoveHandler(cItem)}
                        sx={{
                            marginRight: '0.25rem',
                            '&:last-child': {
                                marginRight: '0rem',
                            },
                        }}
                    ></CustomChip>
                ))}
            </Typography>
        </AddedStatusInfoBox>
    );
}

export default ShowAddedTaskStatusBox;
